module.exports = __webpack_public_path__ + "static/media/SCR-A-062.a806798d.mp3";